import { createAction, props } from '@ngrx/store';
import { SoftwareLicenceState } from '../software-licences-collection.state';

export const loadSoftwareLicences = createAction(
    '[SoftwareLicences] Load',
    props<{ equipmentKey: string; matnr: string; sernr: string }>(),
);

export const loadSoftwareLicencesSuccess = createAction(
    '[SoftwareLicences] Loaded',
    props<{ equipmentKey: string; data: SoftwareLicenceState[] }>(),
);

/**
 * Dispatched when the backend request fails and data is read from file storage instead.
 * Populates the slice like {@link loadSoftwareLicencesSuccess} but signals a cache hit rather
 * than a fresh backend response.
 */
export const hydrateSoftwareLicencesSuccess = createAction(
    '[SoftwareLicences] Loaded from storage',
    props<{ data: Record<string, SoftwareLicenceState[]> }>(),
);

export const loadSoftwareLicencesError = createAction('[SoftwareLicences] Failed', props<{ equipmentKey: string }>());

export const hydrateSoftwareLicences = createAction('[SoftwareLicences] Initialize');

export const deleteSoftwareLicences = createAction('[SoftwareLicences] Delete', props<{ equipmentKeys: string[] }>());
